import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import { apiGateway } from '../../../../config';

import type { AxiosResponse } from 'axios';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../../../../redux/store';
import type { DeliveryMessage, DeliveryMessageState } from '../../../../@types/deliveryMessage';

// ----------------------------------------------------------------------

const initialState: DeliveryMessageState = {
  isLoading: false,
  hasError: false,
  message: undefined,
  deliveryMessage: undefined,
};

const slice = createSlice({
  name: 'deliveryMessage',
  initialState,
  reducers: {
    startLoading(state: DeliveryMessageState) {
      state.isLoading = true;
    },

    hasError(state: DeliveryMessageState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.hasError = true;
      state.message = action.payload;
    },

    resetMessage(state: DeliveryMessageState) {
      state.isLoading = false;
      state.hasError = false;
      state.message = '';
    },

    changeMessage(state: DeliveryMessageState, action: PayloadAction<string>) {
      state.deliveryMessage = action.payload;
    },

// ----------------------------------------------------------------------

    getDeliveryMessageSuccess(state: DeliveryMessageState, action: PayloadAction<DeliveryMessage>) {
      state.isLoading = false;
      state.hasError = false;
      state.message = undefined;
      const message: string = action.payload.message;
      state.deliveryMessage = message;
    },

    updateDeliveryMessageSuccess(state: DeliveryMessageState, action: PayloadAction<DeliveryMessage>) {
      // state.message以外はgetDeliverySuccessと同じ
      state.isLoading = false;
      state.hasError = false;
      state.message = 'successfully updated';
      const message: string = action.payload.message;
      state.deliveryMessage = message;
    },

  }
});

export default slice.reducer;


// ----------------------------------------------------------------------

export function hasError(message: string): AppThunk {
  return (dispatch): void => {
    dispatch(slice.actions.hasError(message));
  }
};

export function resetMessage(): AppThunk {
  return (dispatch): void => {
    dispatch(slice.actions.resetMessage());
  }
};

// ----------------------------------------------------------------------

export function changeMessage(deliveryMessage: string): AppThunk {
  return (dispatch): void => {
    dispatch(slice.actions.changeMessage(deliveryMessage));
  }
};

// ----------------------------------------------------------------------

export function getDeliveryMessage(): AppThunk {
  return async (dispatch): Promise<void> => {
    dispatch(slice.actions.startLoading());

    const token = (await fetchAuthSession()).tokens?.idToken?.toString();
    const response: AxiosResponse = await axios.get<DeliveryMessage>(
      apiGateway + '/deliveryChart/deliveryMessage',
      {
        headers: {
          'Authorization': 'Bearer ' + token,
        },
        timeout: 60000
      }
    );
    dispatch(slice.actions.getDeliveryMessageSuccess(response.data));
  };
};

export function updateDeliveryMessage(): AppThunk {
  return async (dispatch, getState): Promise<void> => {
    dispatch(slice.actions.startLoading());

    const token = (await fetchAuthSession()).tokens?.idToken?.toString();
    const deliveryMessage: string | undefined = getState().deliveryMessage.deliveryMessage;
    if(deliveryMessage!==undefined){
      const params = {
        deliveryMessage
      };
      // リクエスト
      const response: AxiosResponse = await axios.post<DeliveryMessage>(
        apiGateway + '/deliveryChart/deliveryMessage',
        params,
        {
          headers: {
            'Authorization': 'Bearer ' + token,
          },
          timeout: 60000
        }
      );
      dispatch(slice.actions.updateDeliveryMessageSuccess(response.data));
    }
  };
};

// ----------------------------------------------------------------------
